import { Box, Button, Flex, Picture, Image } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"

import { Section, SectionTitle, Text } from "@jewlr/storybook/info"
import { jewlr_t } from "helpers/application"

const DiamondCuration = () => {
  return (
    <Box mb={7}>
      <Section>
        <Box contain>
          <SectionTitle>THE ONE DIAMOND</SectionTitle>
          <Image
            alt="THE ONE"
            height={{ _: "167px", tablet: "297px" }}
            mb={2}
            ml={3}
            src={require("images/info/diamond_curation/theone.svg")}
            style={{ float: "right" }}
            width={{ _: "167px", tablet: "297px" }}
          />
          <Box mb={2}>
            <Text>
              At Jewlr, we believe that when it comes to diamond shopping, the
              simplest approach is the best. With so many factors to consider,
              the excitement of purchasing a diamond ring can turn to
              intimidation. To help you on your journey, our in-house diamond
              experts have developed a simple process to guide you to your
              perfect diamond.
            </Text>
            <Image
              alt="jewlr diamond"
              height={{ _: "39px", desktop: "43px", tablet: "31px" }}
              src={require("images/info/diamond_curation/jewlr_theone_2.svg")}
              style={{ float: "left", marginRight: "16px", marginTop: "5px" }}
              width={{ _: "62px", desktop: "69px", tablet: "49px" }}
            />
            <Text>
              Jewlr&apos;s &ldquo;THE ONE&rdquo; seal indicates the best value
              diamonds on the market. Handpicked by our certified gemologists
              and diamond buyers, these are curated combinations of clarity,{" "}
              {jewlr_t("terms.color")} and cut that offer the highest quality
              for your budget. These combinations will vary depending on the
              carat weight and shape of the diamond (ie princess, round, oval).
              Our in-house experts have developed the below infographic to
              better explain the relation between price and overall appearance.
            </Text>
          </Box>

          <Image
            alt="The One Infographic"
            height="400px"
            mb={3}
            mr={4}
            src={require("images/info/diamond_curation/theone_infographic.svg")}
            style={{ float: "left" }}
            width="397px"
          />
          <Box>
            <Text>
              The price of a diamond can drastically increase when choosing
              certain grades of clarity, color and cut. Too often, these
              significant price jumps are not reflected in the actual look of
              the diamond. In other words, you pay more for a diamond with
              features and characteristics that can only be seen under a
              microscope. When shopping for a diamond, rethink the idea of
              simply buying the most expensive stone you can afford. Instead,
              use Jewlr&apos;s &ldquo;THE ONE&rdquo; seal to guide you to the
              most beautiful diamond for your budget.
            </Text>
            <Text>
              Our gemologists have taken the guesswork out of finding the
              perfect diamond. While browsing our collection, look for
              Jewlr&apos;s THE ONE diamond seal. This symbol indicates the that
              our in-house experts have analyzed and recommended for your ring.
              THE ONE diamond seal is our promise to you, that you are selecting
              the diamond that meets your specifications and is of the highest
              quality.
            </Text>
          </Box>
        </Box>
      </Section>

      <Section>
        <Box
          borderTop="2px solid #ddd"
          contain
          mb={{ _: 4, tablet: 6 }}
          pt={{ _: 4, tablet: 6 }}
        >
          <SectionTitle>DIAMOND CERTIFICATION</SectionTitle>
          <Text>
            Your One & Only engagement ring will include a certificate of
            quality assurance from either the Gemological Institute of America
            (GIA) or the International Gemological Institute (IGI) for your
            diamond, and will be sent with your ring. As the most prestigious
            international association of its kind, the IGI Laboratory Report is
            the language of trust amongst reputable jewelers and{" "}
            {jewlr_t("terms.jewelry")} suppliers everywhere. GIA&apos;s
            establishment of the 4Cs and the international Diamond Grading
            System has set the standard for determining diamond quality
            worldwide. Know that when your receive a GIA/IGI report with your
            diamond purchase, you hold in your hand a guarantee that your
            diamond is the very best available on the market.
          </Text>
          <Flex justifyContent="center">
            <Image
              alt="Gia"
              height={{ _: "39px", tablet: "50px" }}
              mr={3}
              src={require("images/info/diamond_curation/diamond-certification/gia-logo.png")}
              width={{ _: "120px", tablet: "150px" }}
            />
            <Image
              alt="Igi"
              height={{ _: "39px", tablet: "50px" }}
              src={require("images/info/diamond_curation/diamond-certification/igi-logo.png")}
              width={{ _: "30px", tablet: "50px" }}
            />
          </Flex>
        </Box>
      </Section>

      <Section>
        <Box borderTop="2px solid #ddd" contain pt={{ _: 4, tablet: 6 }}>
          <Flex display={{ _: "block", tablet: "flex" }} mb={3}>
            <Image
              alt="The One and Only Collection"
              height={{ _: "215px", tablet: "262px" }}
              src={require("images/info/diamond_curation/oneandonly.svg")}
              width={{ _: "418px", tablet: "496px" }}
            />
            <Picture
              fallback={require("images/info/diamond_curation/oneandonly.jpg")}
              srcSet={[
                {
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `
                    ${require("images/info/diamond_curation/oneandonly.jpg")} 1x,
                  `,
                },
                {
                  media: "(min-width: 768px)",
                  sizes: "100vw",
                  srcSet: `
                    ${require("images/info/diamond_curation/oneandonly.jpg")} 1x,
                    ${require("images/info/diamond_curation/oneandonly_2x.jpg")} 2x,
                  `,
                },
              ]}
            />
          </Flex>
          <SectionTitle
            margin="auto"
            mt={2}
            width={{ _: "148px", tablet: "199px" }}
          >
            A LOVE STORY
          </SectionTitle>
          <Text fontStyle="italic" mb={3}>
            Every happy ending has a beginning, and the story of The One and
            Only Signature Collection is no different. It all started when we at
            Jewlr decided that true love deserves a special celebration. All of
            of our customizable pieces are beautiful in their own way, but an
            engagement ring is something truly special and deserves to be
            treated as such. We decided to create a collection as beautiful and
            timeless as love itself, while still maintaining our commitment to a{" "}
            {jewlr_t("terms.personalized")} experience. Shop the One and Only
            Collection today.
          </Text>
          <Box textAlign="center">
            <Button
              border="1px solid #ddd"
              color="black"
              lineHeight="1"
              margin="auto"
              padding="16px 32px"
              width={{ _: "145px", tablet: "165px" }}
            >
              <Link data-lc="diamond-curation" to="/the-luxury-collection">
                Shop Now
              </Link>
            </Button>
          </Box>
        </Box>
      </Section>
    </Box>
  )
}

export default DiamondCuration
